package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_05_17_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to the depths where our heroes have just defeated Yochlols and Ropers.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The sound of chanting increases, climaxes, and then is replaced by death sounds and silence. The heroes head southwest toward the previous chanting. They see the bodies of six humans, each of which is mangled and crushed by some unholy force. The heroes see a giant 8 foot tall figure wearing robes. The shields of the fallen bodies and the robes of the giant figure feature the same symbol — a red circle with a black 6-fingered hand. When the giant figure sees our heroes, he says “for Jarb” and turns into a tary black goo and something from his body shoots away.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The room is cut off by lava, so the heroes double back to look for other paths. In the distance they hear, “I give you this opportunity to flee.”  The heroes bravely continue south, where they hear a demon voice say something in abyssal. A Goristro named Jarb the Ascended says “Jarb the Ascended will consume you.” Near Jarb is a Chasme named Sklyx. Jarb opens the battle by causing a collapse of lava that hits everyone.  To the east, our heroes spot a Blabrezu named Kral. Jarb smells bad.  Skylx summons a 2nd Chasme into existence, but Bigglesworth quickly savages it with his ruthless blade — the Chasme attempts to flee but is finished off. Goram strikes Jarb and strikes fear into him.")
    }
}
